const Wrapper = require('../Wrapper');
const Template = require('../../announcement/template');

class ResultItemsWrapper extends Wrapper {
    constructor() {
        super();

    }

    loader(enable = true, replace = true) {
        if(enable && replace)
            window.$('#ResultItems').html('');

        enable ? window.$('#loader').show() : window.$('#loader').hide();
    }

    show(items, replace) {

        window.$('#ResultItems').parent().show();
        window.$('#wtsSearchNoResult').hide();

        if(replace && items.length === 0) {
            window.$('#wtsSearchNoResult').show();
            window.$('#ResultItems').parent().hide();
            return;
        }

        try {
            this.renderHTML(items, 'ResultItems', replace);

            if(window.panel)
            {
                window.panel.updateEditor();
            }

            window.addthis.toolbox('.addthis_toolbox');
        } catch (e) {
            console.log(e);
        }
    }

    renderHTML(data, containerID, replace) {
        let container = document.getElementById(containerID);

        if(replace)
        {
            container.innerHTML = '';
        }

        let items = [];

        data.forEach(item => {
            let id = item.id;
            let model = JSON.parse(item.jsonData);

            if(!item.citiesData) return;

            let cities = null;

            try {
                cities = JSON.parse(item.citiesData);
            } catch (e) {
                console.log(e, item, item.citiesData);
            }

            let t = new Template(item, model, cities);
            items.push(t);
            container.innerHTML += t.render();
        });

        items.forEach(item => item.initEvents());
    }

    async getItemsBySearchModel(model) {
        let formData = new FormData();

        formData.append('searchModel', JSON.stringify(model));

        try {
            let response = await (await fetch("/api/announcements-filtering", {method: "POST", body: formData})).json();

            if(response.success == 1) {
                return response.data;
            }

            return [];
        } catch(err) {
            console.log(err);
        }

        return [];
    }
}

module.exports = ResultItemsWrapper;